import React from 'react';
import styles from './Card.module.css';

const Card = ({ 
  children, 
  image, 
  title, 
  subtitle,
  variant = 'default', // default, bordered, elevated
  className = '',
  ...props 
}) => {
  const cardClasses = [
    styles.card,
    styles[variant],
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={cardClasses} {...props}>
      {image && (
        <div className={styles.imageWrapper}>
          <img src={image} alt={title || 'Card image'} className={styles.image} />
        </div>
      )}
      <div className={styles.content}>
        {title && <h3 className={styles.title}>{title}</h3>}
        {subtitle && <h4 className={styles.subtitle}>{subtitle}</h4>}
        {children}
      </div>
    </div>
  );
};

export default Card;